import React, { useEffect, useRef, useState } from 'react';
import { useParser } from '../TranslationTool/useParser';
import { HtmlCustom } from '../common/MandalaMarkup';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { isTib } from '../common/utils';
import { Button, Modal } from 'react-bootstrap';
import { openTabStore, treeStore } from '../../hooks/useCloseStore';

export function TermsParser({ selectMe }) {
    const { changeButtonState } = openTabStore();
    const { setTree } = treeStore();
    const location = useLocation();
    const pathnameRef = useRef(location.pathname);
    const history = useHistory();

    const [passage, setPassage] = useState('');
    const [elclass, setElclass] = useState(' font-100');
    const [origUrl, setOrigUrl] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
    };

    const handleChange = (e) => {
        const value = e.target.value;
        if (isTib(value)) {
            setElclass(' bo');
        } else {
            setElclass(' font-100');
        }
    };

    const returnToPage = (e) => {
        history.push(origUrl);
    };

    const {
        isLoading: isParserLoading,
        data: parsedPhrase,
        isError: isParsingError,
        error: parseError,
    } = useParser(passage);

    useEffect(() => {
        if (window?.mandala) {
            window.mandala.translationListener = (e) => {
                if (e.altKey === true) {
                    const selection = window.getSelection().toString().trim();
                    setPassage(selection);
                    document.getElementById('tibetanPassage').value = selection;
                    const mss = 300;
                    setTimeout(function () {
                        changeButtonState(2);
                        setTimeout(function () {
                            setTree('terms');
                            setTimeout(function () {
                                selectMe();
                                window.scrollTo(0, 0);
                                setOrigUrl(window.location.pathname);
                                /*const time = new Date().toLocaleTimeString();
                                console.log("here: " + time);*/
                            }, mss);
                        }, mss);
                    }, mss);
                }
            };
            document.addEventListener(
                'mousedown',
                window.mandala.translationListener
            );
        }
    }, []);

    let wordsout = [];
    let wordsdone = [];
    if (parsedPhrase?.tokens && parsedPhrase.tokens.length > 0) {
        for (let i = 0; i < parsedPhrase.tokens.length; i += 2) {
            // 2nd include is the entities for "#ERROR"
            if (
                ['/', ',', ';', '(', ')', '[', ']'].includes(
                    parsedPhrase.tokens[i]
                ) ||
                parsedPhrase.tokens[i].includes(
                    '&#35;&#69;&#82;&#82;&#79;&#82;'
                )
            ) {
                continue;
            }
            let termid = parsedPhrase.tokens[i + 1];

            if (termid.includes('.')) {
                termid = termid.split('.')[0];
            }

            if (wordsdone.includes(parsedPhrase.tokens[i])) {
                continue;
            }
            wordsdone.push(parsedPhrase.tokens[i]);
            if (!Number.isInteger(Number(termid))) {
                // for "[Not Found]" etc.
                //console.log("Not found termid: ", termid);
                wordsout.push(
                    <li key={`term-${termid}-${i}`}>
                        <span className="bo">
                            <HtmlCustom markup={parsedPhrase.tokens[i]} />་
                        </span>{' '}
                        (Not Found)
                    </li>
                );
                continue;
            }
            // console.log(parsedPhrase.tokens[i]);
            wordsout.push(
                <li key={`term-nf-${i}`}>
                    <Link
                        to={`/terms/${termid}`}
                        className="bo"
                        rel="noopener noreferrer"
                    >
                        <HtmlCustom markup={parsedPhrase.tokens[i]} />་
                    </Link>
                </li>
            );
        }
    }
    return (
        <div className="c-kmaptree terms parser m-0 p-0">
            <div className="container mt-2 m-0">
                <form onSubmit={handleSubmit} className="pt-1">
                    <div className="form-group">
                        <label htmlFor="messageInput">
                            Enter Tibetan passage to parse <HelpPopup />
                        </label>
                        <textarea
                            id="tibetanPassage"
                            className={'form-control' + elclass}
                            rows="4"
                            onChange={handleChange}
                            placeholder="Type your passage please..."
                        ></textarea>
                    </div>
                    <div className="form-group d-flex justify-content-between w-100">
                        <button
                            type="submit"
                            className="btn btn-primary mt-3"
                            onClick={(e) =>
                                setPassage(
                                    document.getElementById('tibetanPassage')
                                        .value
                                )
                            }
                            title="Parse the phrase in the text box"
                        >
                            Parse
                        </button>
                        {origUrl !== location.pathname && (
                            <div className="d-inline-block align-right">
                                <button
                                    type="submit"
                                    className="btn btn-primary mt-3"
                                    onClick={(e) => returnToPage()}
                                    title="Returns to original page"
                                >
                                    Back
                                </button>
                            </div>
                        )}
                    </div>
                </form>
                {wordsout?.length > 0 && (
                    <div className="mt-3">
                        <ul>{wordsout}</ul>
                    </div>
                )}
            </div>
        </div>
    );
}

function HelpPopup() {
    const [show, setShow] = useState(false);

    return (
        <>
            <Button
                variant="link"
                title="Click for help"
                onClick={() => setShow(true)}
                className="font-85 ml-5"
            >
                Help
            </Button>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Terms Parser</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>
                        The parser will parse a Tibetan passage into individual
                        words or phrases. It will list the words in the area
                        below the textbox, with each word linked to its entry in
                        the dictionary.{' '}
                    </p>
                    <p>
                        In addition, one can highlight a Tibetan passage on the
                        page and press option (Mac) or alt (Windows) while
                        clicking on the selection to parse that highlighted
                        passage.
                    </p>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShow(false)}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}
